import React from 'react';
export function SubscriberIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.021 16.269C17.447 15.002 19 12.224 19 9c0-4.418-2.546-8-7-8-4.455 0-7 3.582-7 8 0 3.224 1.553 6.002 3.979 7.269-.143.86-.984 1.171-1.936 1.524C5.641 18.313 4 18.922 4 21.5V23h16v-1.5c0-2.578-1.641-3.187-3.043-3.707-.952-.353-1.793-.665-1.936-1.524zM17 9c0 3.616-2.301 6-5 6s-5-2.384-5-6c0-1.843.532-3.364 1.373-4.385C9.18 3.635 10.36 3 12 3c1.639 0 2.82.635 3.627 1.615C16.468 5.635 17 7.157 17 9z"
  }));
}